import { render } from "./search-filter.vue?vue&type=template&id=236a0a82&scoped=true"
import script from "./search-filter.vue?vue&type=script&lang=js"
export * from "./search-filter.vue?vue&type=script&lang=js"

import "./search-filter.vue?vue&type=style&index=0&id=236a0a82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236a0a82"]])

export default __exports__